import http from "./HttpService";
import { API_BASE_CAMPAIGN, API_BASE_CONTENT } from "../../constants/index";
import { getVersionId } from "modules/EmailBrowser/utils";
import { getCSRFToken } from "../../utils";
import axios from "axios";

export function getWhnArticlesService(limit: number, offset: number) {
  let versionId = getVersionId();
  return http.get(
    API_BASE_CONTENT + `whats_happening_now_articles/?limit=${limit}&offset=${offset}&version_id=${versionId}`,
    { headers: { "X-CSRFToken": getCSRFToken() } }
  );
}

let cancelTokenEdition: any;
export function getArticleofEditon(data: any) {
  //Check if there are any previous pending requests
  if (typeof cancelTokenEdition != typeof undefined) {
    cancelTokenEdition && cancelTokenEdition.cancel("Operation canceled due to new request.");
  }

  //Save the cancel token for the current request
  cancelTokenEdition = axios.CancelToken.source();
  return http.get(
    API_BASE_CAMPAIGN + `get_draft_version_content/?version_id=${data}`,
    { cancelToken: cancelTokenEdition.token } //Pass the cancel token to the current request);
  );
}

export function clearAllCurationService(versionId: number) {
  let payload = new FormData();
  payload.append("version_id", versionId.toString());
  return http.post(API_BASE_CONTENT + `delete_all_curated_articles/`, payload);
}

export function removeSingleArticleFromCurationService(versionId: number, articleId: number) {
  let payload = new FormData();
  payload.append("version_id", versionId.toString());
  payload.append("article_id", articleId.toString());
  return http.post(API_BASE_CONTENT + `delete_curated_article/`, payload);
}
